import { Box } from "@stenajs-webui/core";
import { Icon, InputSpinner, stenaAngleDown } from "@stenajs-webui/elements";
import { CrudStatusIndicator } from "@stenajs-webui/grid";
import * as React from "react";
import { useState } from "react";
import { CellFieldClickGate } from "@/components/cell-field-click-gate/CellFieldClickGate";
import { NegotiationStatusSelect } from "@/components/data-driven-inputs/selects/negotiation-status-select/NegotiationStatusSelect";
import { getApolloErrorMessage } from "../../../../../lib/GraphQlErrorParser";
import { NegotiationStatusByYear } from "../../customer-list/types";
import { useSetNegotiationStatus } from "../hooks/UseSetNegotiationStatusMutation";
import { SetChildrenNegotiationStatusModal } from "./SetChildrenNegotiationStatusModal";
import { getYear } from "date-fns";
import { NegotiationStatusFetcherCustomerFragment } from "@/gql/graphql";

interface Props {
  customer: NegotiationStatusFetcherCustomerFragment;
  negotiationYear: number;
  border?: string;
  borderRadius?: string;
  isInTable: boolean;
}

export const CustomerNegotiationStatusEditor: React.FC<Props> = ({
  customer,
  border,
  borderRadius,
  negotiationYear,
  isInTable,
}) => {
  const { error, loading, setNegotiationStatus } = useSetNegotiationStatus();
  const [negStatus, setNegStatus] = useState<
    NegotiationStatusByYear | undefined
  >(undefined);

  const year = negotiationYear ?? getYear(new Date());

  const setCustomerNegotiationStatus = (
    negotiationStatus: NegotiationStatusByYear | undefined
  ) => {
    if (negotiationStatus) {
      setNegotiationStatus([customer.id], year, negotiationStatus).map(
        (status) => {
          return status.catch((e) => {
            console.error(e);
          });
        }
      );

      if (customer?.isParent && customer.noOfChildren > 0) {
        setNegStatus(negotiationStatus);
      }
    }
  };

  return (
    <>
      <SetChildrenNegotiationStatusModal
        negotiationStatus={negStatus}
        negotiationYear={year}
        customer={customer}
      />
      <CellFieldClickGate
        disableClick={loading}
        label={customer.negotiationStatusByYear?.name ?? ""}
        border={border}
        borderRadius={borderRadius}
        right={
          loading ? (
            <InputSpinner />
          ) : error ? (
            <CrudStatusIndicator
              crudStatus={{
                hasError: true,
                errorMessage: getApolloErrorMessage(error),
              }}
            />
          ) : (
            <Icon icon={stenaAngleDown} size={14} />
          )
        }
        renderContent={({ onRequestClose }) => (
          <Box width={"100%"}>
            <NegotiationStatusSelect
              value={customer.negotiationStatusByYear ?? undefined}
              onValueChange={(e) => setCustomerNegotiationStatus(e)}
              autoFocus
              openMenuOnFocus
              onMenuClose={onRequestClose}
              menuPortalTarget={document.body}
            />
          </Box>
        )}
      />
    </>
  );
};
